
class SelectDocumentCell extends UITableViewCell
{
    delegate = null;

    private dateLabel:MUILabel = null;
    private documentIDLabel:MUILabel = null;
    private legalNameLabel:MUILabel = null;
    private totalLabel:MUILabel = null;
    private addButton:MUIButton = null;

    awakeFromHTML(){
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.documentIDLabel = MUIOutlet(this, "document-id-lbl", "MUILabel");
        this.legalNameLabel = MUIOutlet(this, "client-name-lbl", "MUILabel");
        this.totalLabel = MUIOutlet(this, "total-lbl", "MUILabel");
        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        if (this.addButton != null) this.addButton.setAction(this, this.addAction);

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:MIOManagedObject = null;
    set item (item:MIOManagedObject){
        this._item = item;
        
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        if (item instanceof ArchivedTicket) {                    
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.date);
            this.documentIDLabel.text = item.legalDocumentID;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.linkedLegalEntityName;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.totalPrice);
        }
        else if (item instanceof SupplierNote) {
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.stockDate);
            this.documentIDLabel.text = item.externalReference ?? item.documentID;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.originName;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.baseAmount);
        }
        else if (item instanceof SalesInvoice) {
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.date);
            this.documentIDLabel.text = item.documentNumber;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.legalEntity.name;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.totalAmount);
        }
        else if (item instanceof PurchaseInvoice) {
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.date);
            this.documentIDLabel.text = item.documentNumber;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.legalEntity?.name;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.totalAmount);
        }
        else if (item instanceof EmployeePayroll) {
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.beginDate);
            this.documentIDLabel.text = item.period != null ? String(item.period) : null;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.worker?.name;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.grossAmount);
        }
        else if (item instanceof Loan) {
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.startDate);
            this.documentIDLabel.text = item.name;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.reference;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.capitalAmount);
        }
        else if (item instanceof BankMovement) {
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.date);
            this.documentIDLabel.text = item.concept;
            if (this.legalNameLabel != null) this.legalNameLabel.text = item.beneficiaryName;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.amount);
        }
        else if (item instanceof ArchivedDocument) {
            // ArchivedInvoice and any other archived document not handled above
            if (this.dateLabel != null) this.dateLabel.text = ad.dateTimeFormatter.stringFromDate(item.date);
            this.documentIDLabel.text = item.legalDocumentID ?? item.documentID;
            if (this.legalNameLabel != null) this.legalNameLabel.text = (item as any).invoiceLegalEntityName ?? (item as any).linkedLegalEntityName;
            if (this.totalLabel != null) this.totalLabel.text = ad.currencyFormatter.stringFromNumber(item.totalPrice);
        }
    }
    
    private addAction(){
        if (this.delegate != null) this.delegate.addDocumentFromCell(this, this._item);        
    }

    set selectedItem(value:boolean){
        this.addButton.hidden = value;
        if (value == true){
            if (this.dateLabel != null) MUICoreLayerAddStyle(this.dateLabel.layer, "light");
            if (this.documentIDLabel != null) MUICoreLayerAddStyle(this.documentIDLabel.layer, "light");
            if (this.legalNameLabel != null) MUICoreLayerAddStyle(this.legalNameLabel.layer, "light");
            if (this.totalLabel != null) MUICoreLayerAddStyle(this.totalLabel.layer, "light");
        }
        else {
            if (this.dateLabel != null) MUICoreLayerRemoveStyle(this.dateLabel.layer, "light");
            if (this.documentIDLabel != null) MUICoreLayerRemoveStyle(this.documentIDLabel.layer, "light");
            if (this.legalNameLabel != null) MUICoreLayerRemoveStyle(this.legalNameLabel.layer, "light");
            if (this.totalLabel != null) MUICoreLayerRemoveStyle(this.totalLabel.layer, "light");            
        }        

    }
}